const CartStep = {
  2009: 12,
  2010: 12,
  2011: 12,
  2012: 12,
  2004: 15,
  2005: 15,
  2006: 15,
  2007: 15,
  2008: 15,
};

export const cartStep = ticketTypeId => CartStep[ticketTypeId] ?? 1;

export const isCabofoliaEvent = eventId =>
  ['01GKR6QZSWLJ43', '01GJ8EYRK0S1RZ', '01GJGCNXWWWCCN'].includes(eventId);

export const isBaroesEvent = eventId => '01H5XHDPB7GZSA' === eventId;

export const isJogosEvent = eventId => '01HA65LT5YNBXT' === eventId;

export const isFerrugemEvent = eventId => '01HF3CPFESYU3L' === eventId;

export const isFeijoadaBarrocoEvent = eventId => '01HOO1DHG4NUHE' === eventId;

export const isCabofoliaRealEvent = eventId =>
  ['01HJALLE2QUKH8', '01HRE36XEKUGGA', '01HOPBXQ5I1IBQ'].includes(eventId);

export const isBrasilEmpreendedor = eventId => '01HT9H42XQRAOH' === eventId;

export const is303StageNextLevel = eventId => '01HXMY8QAGKX6L' === eventId;

export const isJhordanMatheus = eventId => '01JE39JHHH6LF6' === eventId;
